<template>
  <div class="slogan-title">
    <div class="blue-title">
      <div class="blue-line"></div>
      <h4>{{ theTitle }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "fromTitle",
  methods: {
    goBack() {
      history.go(-1);
    },
  },
  props: ["theTitle"],
};
</script>

<style lang="less" rel="stylesheet/less">
.slogan-title {
  width: 100%;
  height: 40px;
  background: #edf1f8;
  padding: 0 16px;

  .blue-title {
    display: flex;
    line-height: 40px;
    .blue-line {
      width: 3px;
      height: 16px;
      /*background-color: rgb(19, 104, 242);*/
      background-color: #0096ff;
      margin-top: 12px;
    }

    > h4 {
      font-size: 16px;
      color: #2c3542;
      letter-spacing: 0;
      font-weight: 600;
      padding-left: 8px;
    }
  }
}
</style>
